import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { FloorModel } from "@models/master-data/floorModel"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class FloorService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Floor/GetAll", { params })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Floor/Get", {
      params: { id },
    })
    const { result } = res.data
    return FloorModel.assign(result)
  }

  public async createOrUpdate(body: any) {
    const res = await http.post("api/services/app/Floor/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/Floor/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(): Promise<any> {
    const res = await http.get("api/services/app/Floor/GetList")
    const { result } = res.data
    return result
  }
  public async exportExcel(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportFloor", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-FLOOR-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
  public async importFloor(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)

    const result = await http.post("api/Imports/ImportFloor", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })

    return result.data.result
  }

  public async exportTemplateFloor(): Promise<any> {
    const res = await http.get("api/Export/ExportFloor", {
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-FLOOR-TEMPLATE-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
}

export default new FloorService()
